"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const Calendar = ({ size = 16, fill = "#E6E6E6", name = "Calendar", ...rest }) => {
    return (react_1.default.createElement(Base_1.Base, { size: size, fill: fill, ...rest },
        react_1.default.createElement("title", null, name),
        react_1.default.createElement("path", { d: "M5,3H3V0h2V3zM14,1v3h-4V1H6v3H2V1H1v14h14V1H14zM14,14H2V5h12V14zM13,3h-2V0h2V3z" }),
        react_1.default.createElement("path", { opacity: "0.6", d: "M12,12h-2v-2h2V12zM12,9h-2V7h2V9zM9,12H7v-2h2V12zM9,9H7V7h2V9zM6,12H4v-2h2V12z" })));
};
exports.Calendar = Calendar;
//# sourceMappingURL=Calendar.js.map